import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './css/editArticle.css';
import { GetArticle, PutArticle } from '../../../Redux/Slice/ArticleSlice';
import { useEffect, useState } from 'react';
import loadingGif from './../../../images/loading.gif';
import { getImageUrl } from '../../..';

const EditArticle = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { Articles } = useSelector((state) => state.article);
    const { isAuthadmin } = useSelector((state) => state.admin);

    const [formData, setFormData] = useState({
        titre: '',
        texte: '',
        lien: '',
        auteur: '',
        photo: ''
    });

    const [editorLoaded, setEditorLoaded] = useState(false);

    useEffect(() => {
        dispatch(GetArticle());
    }, [dispatch]);
    useEffect(() => {
        if (!isAuthadmin) navigate('/admin/login');
      }, [isAuthadmin, navigate]);
    useEffect(() => {
        if (Articles && id) {
            const articleToEdit = Articles.find(article => article._id === id);
            if (articleToEdit) {
                setFormData(articleToEdit);
            }
        }
    }, [Articles, id]);

    useEffect(() => {
        setEditorLoaded(true);
    }, []);

    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        setFormData(prevData => ({
            ...prevData,
            texte: data
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simple validation before dispatching
        if (!formData.titre || !formData.texte || !formData.auteur) {
            alert('Veuillez remplir tous les champs obligatoires.');
            return;
        }
        dispatch(PutArticle({ id, data: formData }));
        navigate('/admin/article/visible');
    };

    if (!editorLoaded) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <img src={loadingGif} alt="Chargement..." />
            </div>
        );
    }

    return (
        <div className='edit-Article'>
            <div className='FormContainer'>
                <form onSubmit={handleSubmit}>
                    <div className='FormContainerItem'>
                        <label className='labelEdit'>Titre</label>
                        <input
                            className='inputView'
                            type='text'
                            name='titre'
                            value={formData.titre}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className='FormContainerItem'>
                        <label className='labelEdit'>Texte</label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.texte}
                            onChange={handleEditorChange}
                        />
                    </div>
                    <div className='FormContainerItem'>
                        <label className='labelEdit'>Lien</label>
                        <input
                            className='inputView'
                            type='text'
                            name='lien'
                            value={formData.lien}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='FormContainerItem'>
                        <label className='labelEdit'>Auteur</label>
                        <input
                            className='inputView'
                            type='text'
                            name='auteur'
                            value={formData.auteur}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group-Article">
                        <label className='labelEdit'>Image</label>
                        {formData.photo && (
                            <img
                                src={getImageUrl(formData.photo)}
                                alt="Icone"
                                className='imageEdit-Article'
                            />
                        )}
                    </div>
                    <div className='Bouton-Edit-Article'>
                        <button type="submit" className='btn btn-primary edit-modifier-Article'>Modifier</button>
                        <button type="button" className='btn btn-secondary' onClick={() => navigate('/admin/Accueil')}>Annuler</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditArticle;
